import BaseService from './_base.service';

export const languageService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/language/page/"+page+"/"+size, callback)
}
function search(page,size,filter, callback) {
    return BaseService.post("/language/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/language/combo/", callback,)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/language/"+id, body, callback, false)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/language/", body, callback, false)
}

function one(id,callback) {
    return BaseService.get("/language/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/language/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/language/"+id+"/logic", callback);
}
